module.exports = __webpack_public_path__ + "img/validation-cam.f0b9a125.svg";